import "../../../styles/faq-accordion.css";

const FAQItem = ({ title, content, expandedIndices = [], index = 0, handleIndexToggle }) => {
    const isExpanded = expandedIndices?.includes(index);

    return (
        <div className={`faq-item ${isExpanded ? 'expanded' : ''}`}>
            <div className="container-default small width-100 w-container">
                <button 
                    className="faq-header"
                    onClick={() => handleIndexToggle(index)}
                    aria-expanded={isExpanded}
                >
                    <h3 className="faq-title">{title}</h3>
                    <div className="faq-icon">
                        <span className="faq-icon-bar horizontal"></span>
                        <span className="faq-icon-bar vertical"></span>
                    </div>
                </button>
                <div className="faq-content-wrapper">
                    <div className="faq-content">
                        <p>{content}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FAQItem;
